import React from 'react';
import request from "arcdynamic-request";
import {SELLERS} from "../../consts/tables";
import Alert from "../Alert";
import SellerForm from "../SellerForm/SellerForm";

export default class SellerDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            paneIndex: 0,
            isBusy: null,
            error: null,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.saveData();
    }

    handleChange(key, value) {
        const data = {...this.state.data};
        data[key] = value;
        this.setState({data});
    }

    handleDropdownChange(data) {
        this.setState({data});
    }

    saveData() {
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
        });

        Object.keys(this.state.data).forEach(k => {
            if (!this.state.data[k] || k === 'undefined') {
                const newData = {...this.state.data};
                delete newData[k];
                this.setState({data: newData})
            }
        });

        return request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.datasource.table.Data.updateByTableCode',
            params: [SELLERS, {
                value: [
                    this.state.data,
                ],
            }],
        }).then(res => {
            if (res && res.success) {
                this.setState({isBusy: false});
                this.props.savedNewItem(res.data[0]);

                if (this.props.closeDrawer) {
                    this.props.closeDrawer();
                    setTimeout(() => this.setState({data: {}}))
                }
            } else {
                this.setState({
                    isBusy: null,
                    error: res && res.message ? res.message : 'Unspecified error',
                });
            }
        });
    }

    render() {
        const data = this.state.data;

        return (
            <React.Fragment>
                <SellerForm data={data}
                            paneIndex={this.state.paneIndex}
                            handleSubmit={this.handleSubmit}
                            handleCancel={this.props.closeDrawer}
                            handleParentChange={this.handleChange}
                            handleParentDropdownChange={this.handleDropdownChange}
                            handlePaneChange={(key) => this.setState({paneIndex: key})}
                />
                {this.state.error && <Alert type='error'>{this.state.error}</Alert>}
            </React.Fragment>
        )
    }
}